/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const HomeShade = (props: any) => (
<svg {...props}   viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<g id="24px/home-shade">
<path id="Vector 75" d="M4 19V11.026C4 10.6967 4.16212 10.3885 4.43347 10.202L12 5" stroke="#E5E8EF" strokeWidth="inherit" strokeLinecap="round"/>
<path id="Vector 76" d="M15.8947 21H19C20.1046 21 21 20.1046 21 19V10.6914C21 10.0587 20.7006 9.46328 20.1926 9.08596L13.1462 3.85142C12.4605 3.34204 11.5269 3.32438 10.8225 3.80745L3.86894 8.57557C3.32507 8.94851 3 9.56558 3 10.225V19C3 20.1046 3.89543 21 5 21H8.10526C9.20983 21 10.1053 20.1046 10.1053 19V15.6947C10.1053 14.6483 10.9536 13.8 12 13.8C13.0464 13.8 13.8947 14.6483 13.8947 15.6947V19C13.8947 20.1046 14.7902 21 15.8947 21Z" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
</g>
</svg>
);

export default HomeShade;